import { Flex } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { useStructureViewFlowDiagram } from "../../../../hooks/useStructureViewFlowDiagram";
import { ObjectName } from "../../../../utils/enums";
import { StructureViewMode } from "../../../StructureView/StructureView.constants";
import { CustomFlowNode } from "../../../StructureViewFlowDiagram/CustomGraphComponents/CustomFlowNode/CustomFlowNode";
import { getFlowNodesFromNodes } from "../../../StructureViewFlowDiagram/utils/getFlowNodesFromNodes";

function getIconColumn<T extends { id?: number }>(
  objectName: ObjectName,
  siteId: number
): Array<MRT_ColumnDef<T>> {
  return objectName === ObjectName.Generator ||
    objectName == ObjectName.Consumer ||
    objectName === ObjectName.Storage
    ? [
        {
          header: "",
          id: "icon",
          Cell: ({ row }) =>
            row.original.id != null ? (
              <FlowNodeIconCell componentId={row.original.id} siteId={siteId} />
            ) : null,
          size: 36,
          mantineTableHeadCellProps: {
            style: {
              flex: "0 0 auto"
            }
          },
          mantineTableBodyCellProps: {
            style: {
              flex: "0 0 auto"
            }
          },
          enableSorting: false,
          enableResizing: false
        }
      ]
    : [];
}

function FlowNodeIconCell({
  componentId,
  siteId
}: {
  componentId: number;
  siteId: number;
}) {
  const { data } = useStructureViewFlowDiagram(siteId);
  if (!data) return null;

  const generatorNode = (data.nodes || []).filter(
    (node) => node.data?.componentId === componentId
  );
  const generatorFlowNodes = getFlowNodesFromNodes(
    generatorNode,
    data.edges || []
  );
  if (!generatorFlowNodes.length) return null;
  const node = generatorFlowNodes[0];

  return (
    <Flex justify="center" w="100%">
      <CustomFlowNode
        data={{ ...node.data, size: 24 }}
        deletable={false}
        disableHandles
        draggable={false}
        dragging={false}
        hasCompanyFeaturesBorderPadding="1px"
        hideLabel
        id={node.id}
        isConnectable={false}
        mode={StructureViewMode.New}
        positionAbsoluteX={0}
        positionAbsoluteY={0}
        selectable={false}
        selected={false}
        type={node.type}
        zIndex={0}
      />
    </Flex>
  );
}

export { getIconColumn };
